// APIデータを現在のアプリケーション形式にマッピングする関数（ステータス判定なし）

// serviceKindからプラットフォーム名を取得する関数
const getPlatformFromServiceKind = (serviceKind) => {
  switch (serviceKind) {
    case 'youtube':
      return 'YouTube';
    case 'twitcasting':
      return 'ツイキャス';
    case 'twitch':
      return 'Twitch';
    default:
      return 'YouTube'; // デフォルトはYouTube
  }
};

export const mapApiDataToStreamData = (apiData) => {
  if (!apiData) {
    return [];
  }

  const mappedData = [];
  let idCounter = 1;

  // 様々なデータ構造に対応
  let items = [];
  
  if (apiData.items && Array.isArray(apiData.items)) {
    // 日付別グループ構造
    apiData.items.forEach(dateGroup => {
      if (dateGroup.items && Array.isArray(dateGroup.items)) {
        // 各アイテムに日付情報を追加
        const itemsWithDate = dateGroup.items.map(item => ({
          ...item,
          date: dateGroup.date
        }));
        items = items.concat(itemsWithDate);
      }
    });
  } else if (Array.isArray(apiData)) {
    // 配列の場合
    items = apiData;
  } else if (apiData.data && Array.isArray(apiData.data)) {
    // dataプロパティの場合
    items = apiData.data;
  }

  items.forEach(item => {
    const originalStartTime = item.scheduledStartTime || item.snippet?.scheduledStartTime || new Date().toISOString();
    
      const mappedItem = {
        id: idCounter++,
        title: item.title || item.snippet?.title || 'タイトル不明',
        streamer: item.channelTitle || item.snippet?.channelTitle || 'ストリーマー不明',
        description: item.description || item.snippet?.description || '',
        thumbnailUrl: item.videoThumbnails?.url || 
                     item.videoThumbnails?.maxres?.url || 
                     item.videoThumbnails?.standard?.url || 
                     item.videoThumbnails?.high?.url || 
                     item.videoThumbnails?.medium?.url || 
                     item.videoThumbnails?.default?.url ||
                     item.snippet?.thumbnails?.maxres?.url ||
                     item.snippet?.thumbnails?.standard?.url ||
                     item.snippet?.thumbnails?.high?.url ||
                     item.snippet?.thumbnails?.medium?.url ||
                     item.snippet?.thumbnails?.default?.url ||
                     '/no_image.jpg',
        channelThumbnails: item.channelThumbnails || null,
        startTime: originalStartTime,
        platform: getPlatformFromServiceKind(item.serviceKind),
        url: item.videoUrl || item.url || '#',
        channelUrl: item.channelUrl || null,
        // APIから取得した生のステータス情報を保持
        apiStatus: item.status,
        liveBroadcastContent: item.liveBroadcastContent,
        status: item.status || 'upcoming', // APIのstatusを使用、なければデフォルト値
        isFavorite: false,
        // アーカイブフラグを追加
        isArchive: item.date === 'アーカイブ',
        // APIの日付グループを保持
        displayDate: item.date
      };
    
    mappedData.push(mappedItem);
  });

  return mappedData;
};

// APIデータから日付リストを抽出する関数
export const extractDatesFromApiData = (apiData) => {
  const dates = [];
  
  if (apiData && apiData.items && Array.isArray(apiData.items)) {
    apiData.items.forEach(dateGroup => {
      if (dateGroup.date && dateGroup.date !== 'アーカイブ') {
        // 「アーカイブ」は日付リストから除外
        dates.push(dateGroup.date);
      }
    });
  }
  
  return dates;
};

// APIからデータを取得する関数
export const fetchStreamData = async (apiUrl) => {
  try {
    const response = await fetch(apiUrl, {
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    const mappedData = mapApiDataToStreamData(data);
    const availableDates = extractDatesFromApiData(data);
    
    return { streams: mappedData, dates: availableDates };
  } catch (error) {
    console.error('データの取得に失敗しました:', error);
    return { streams: [], dates: [] }; // エラー時は空配列を返す
  }
};
